export default __webpack_public_path__ + "static/media/wht-cat-7.83c34906.svg";